// extracted by mini-css-extract-plugin
export var brand = "_bz-9";
export var compact = "_bz-6";
export var extraSmall = "_bz-7";
export var icon = "_bz-0";
export var large = "_bz-4";
export var light = "_bz-1";
export var medium = "_bz-5";
export var outline = "_bz-b";
export var primaryDark = "_bz-a";
export var primaryLight = "_bz-8";
export var primaryModern = "_bz-c";
export var success = "_bz-2";
export var successSolid = "_bz-3";